import React, { useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Input from '@material-ui/core/Input'

const useStyles = makeStyles(theme => ({
  input: {
    width: '100%',
    '& input': {
      textAlign: 'right',
    },
    border: `1px dotted rgba(0, 0, 0 ,0)`,
  },
  highlightedInput: {
    color: theme.palette.primary.main,
    borderTop: `1px solid rgba(0, 0, 0, 0.42)`,
    borderRight: `1px solid rgba(0, 0, 0, 0.42)`,
    borderLeft: `1px solid rgba(0, 0, 0, 0.42)`,
  },
}))

const NumberInput = ({
  value,
  highlight,
  onChange,
  onFocus,
  onCommit,
  onBlur,
}) => {

  const classes = useStyles()
  const inputRef = useRef()
  const [ focusValue, setFocusValue ] = useState('')

  const getInput = () => {
    return inputRef.current.querySelector('input')
  }

  const keyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault()
      getInput().blur()
    }
  }

  const change = (e) => {
    const num = parseFloat(e.target.value)
    onChange(isNaN(num) ? e.target.value : num)
  }

  const focus = (e) => {
    setFocusValue(getInput().value)
    getInput().select()
    onFocus && onFocus()
  }

  const blur = (e) => {
    if(getInput().value != focusValue) onCommit()
    onBlur && onBlur()
  }

  return (
    <Input
      className={ classes.input }
      classes={{
        input: highlight ? classes.highlightedInput : null,
      }}
      value={ value }
      type="number"
      ref={ inputRef }
      onKeyDown={ keyDown }
      onChange={ change }
      onFocus={ focus }
      onBlur={ blur }
    />
  )
}

export default NumberInput

